/*
 *		Copyright (c) 2011-2022 Acronis Incorporated. All rights reserved.
 *
 *	This source code may be used only by organizations licensed to use Acronis Access, in conjunction with normal Acronis Access usage.
 *	No portion of it may be redistributed or modified without the written permission of Acronis, Inc. See the Acronis Software License Agreement for more information.
 */

'use strict';

angular.module('accessWebClient')
    .directive('accChipsInput', ['$timeout', 'template', ($timeout, template) => ({
        replace: true,
        restrict: 'E',
        require: '^ngModel',
        scope: {
            loadSuggestions: '&',
            placeholder: '@',
            required: '@',
            separators: '@',
            validateInput: '&',
            chipFormatter: '&'
        },
        templateUrl: template('nodes/_chips_input'),
        link: ($scope, $element, __, ngModel) => {
            if (!ngModel) {
                throw new Error('Please provide ngModel attribute.');
            }

            /**
             * @type {string[]}
             */
            let separators = [];
            /**
             * @type {RegExp}
             */
            let separatorsRegexp;
            let lastInputValue = '';
            /**
             * @type {string[]}
             */
            let splittedValues = [];

            Object.defineProperties($scope, {
                inputValue: {
                    enumerable: true,
                    value: '',
                    writable: true
                },
                inputPlaceholder: {
                    get: () => $scope.chips.length === 0 ? $scope.placeholder : ''
                }
            });

            ngModel.$validators.required = (modelValue, viewValue) => {
                const value = modelValue || viewValue;

                if (!$scope.required) {
                    return true;
                }

                return value != null && value.length > 0;
            };

            $scope.chips = [];

            $scope.$watch('inputValue', (nextValue) => {
                splittedValues = nextValue
                    .split(separatorsRegexp)
                    .map((value) => value.trim());

                const isValid = nextValue.length == 0 || splittedValues.some(_isValueValid);

                ngModel.$setValidity('invalidInput', isValid);
            });

            $scope.$watch(
                () => ngModel.$viewValue,
                (newValue, oldValue) => {
                    if (newValue !== oldValue) {
                        $scope.chips = newValue.map(_getChipData);
                    }
                }
            );

            $scope.$watch('separators', (newSeparators) => {
                separators = (newSeparators || ' ').split('');
                separatorsRegexp = new RegExp("[\\" + separators.join('\\') + "]");
            });

            $scope.handleInputKeyUp = (event) => {
                const { code: codePressed, key: keyPressed } = event;
                const input = $scope.inputValue;
                ngModel.$setDirty();

                if (codePressed === 'Backspace' && lastInputValue.length === 0) {
                    $scope.removeChip($scope.chips.length - 1);
                    return;
                } else {
                    lastInputValue = input;
                }

                if (separators.indexOf(keyPressed) === -1) {
                    return;
                }

                _addChips();
            };

            $scope.handleBlur = () => $timeout(() => {
                ngModel.$setTouched();

                _addChips(true);
            }, 200);

            $scope.removeChip = (chipIndex) => {
                if (chipIndex < 0 && chipIndex >= ngModel.$viewValue.length) {
                    return;
                }

                ngModel.$setViewValue(ngModel.$viewValue.filter((_, index) => index !== chipIndex));
            };

            $scope.handlePaste = _addChips;

            $scope.selectSuggestion = (suggestionValue) => {
                ngModel.$setViewValue([
                    ...(ngModel.$viewValue || []),
                    suggestionValue
                ]);

                _resetInputValue();
            };

            function _addChips(onBlur = false) {
                if (
                    ngModel.$error.invalidInput ||
                    splittedValues.length === 0
                ) {
                    return;
                }

                const validChips = splittedValues.filter(_isValueValid);
                const leftoverInput = splittedValues.filter(_isValueInvalid).join(separators[0]);

                ngModel.$setViewValue([
                    ...(ngModel.$viewValue || []),
                    ...validChips
                ]);

                _resetInputValue(leftoverInput, !onBlur);
            }

            function _resetInputValue(leftoverInput = '', focus = true) {
                lastInputValue = '';
                $scope.inputValue = leftoverInput;
                splittedValues = [];

                if (focus) {
                    $('.chips-input__input', $element).focus();
                }
            }

            function _getChipData(chip) {
                const formatted = $scope.chipFormatter({ chip });

                if (angular.isDefined(formatted)) {
                    return { ...formatted };
                }

                return { label: chip.toString() };
            }

            function _isValueValid(value) {
                return value.length > 0 && ($scope.validateInput({ input: value }) !== false);
            }

            function _isValueInvalid(value) {
                return !_isValueValid(value);
            }
        }
    })]);
